import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumToWordsService {

  constructor() { }
  // convertToWords(amount: number): string {
  //   const ones = [
  //     "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  //     "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  //   ];
  //   const tens = [
  //     "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  //   ];
  //   const thousands = [
  //     "", "Thousand", "Million", "Billion"
  //   ];

  //   let words = '';
  //   let i = 0;

  //   if (amount === 0) return "Rupees Zero Only";

  //   while (amount > 0) {
  //     if (amount % 1000 !== 0) {
  //       words = this.helper(amount % 1000) + thousands[i] + ' ' + words;
  //     }
  //     amount = Math.floor(amount / 1000);
  //     i++;
  //   }

  //   return "Rupees " + words.trim() + " Only";
  // }

  // private helper(num: number): string {
  //   const ones = [
  //     "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  //     "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  //   ];
  //   const tens = [
  //     "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  //   ];

  //   let str = '';

  //   if (num >= 100) {
  //     str += ones[Math.floor(num / 100)] + " Hundred ";
  //     num %= 100;
  //   }

  //   if (num >= 20) {
  //     str += tens[Math.floor(num / 10)] + " ";
  //     num %= 10;
  //   }

  //   if (num > 0) {
  //     str += ones[num] + " ";
  //   }
  //   return str;
  // }
  convertToWords(amount: number): string {
    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
    const thousands = [
      "", "Thousand", "Million", "Billion"
    ];
  
    let words = '';
    let i = 0;
  
    // Split the amount into integer and decimal parts (use 'let' to allow modification)
    let [integerPart, decimalPart] = amount.toString().split('.').map(Number);
  
    // Convert integer part to words
    if (integerPart === 0) {
      words = "Zero ";
    } else {
      while (integerPart > 0) {
        if (integerPart % 1000 !== 0) {
          words = this.helper(integerPart % 1000) + thousands[i] + ' ' + words;
        }
        integerPart = Math.floor(integerPart / 1000);
        i++;
      }
    }
  
    words = "Rupees " + words.trim();
  
    // Convert decimal part (if it exists) to words
    if (decimalPart) {
      const decimalWords = this.convertDecimalToWords(decimalPart);
      words += " and " + decimalWords + " Paise";
    }
  
    return words + " Only";
  }
  
  private helper(num: number): string {
    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
      "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    let str = '';
  
    if (num >= 100) {
      str += ones[Math.floor(num / 100)] + " Hundred ";
      num %= 100;
    }
  
    if (num >= 20) {
      str += tens[Math.floor(num / 10)] + " ";
      num %= 10;
    }
  
    if (num > 0) {
      str += ones[num] + " ";
    }
  
    return str;
  }
  
  private convertDecimalToWords(decimal: number): string {
    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"
    ];
  
    let decimalWords = '';
    const decimalStr = decimal.toString();
  
    for (let i = 0; i < decimalStr.length; i++) {
      decimalWords += ones[parseInt(decimalStr[i])] + " ";
    }
  
    return decimalWords.trim();
  }
  
  
}
